export const CONTACT = {
  brand: "O Fernando dos Vidros",
  instagram: "https://www.instagram.com/ofernandodosvidros",
  instagramHandle: "@ofernandodosvidros",
  facebook: "https://www.facebook.com/people/Ofernandodosvidros/61593300470144/",
  facebookHandle: "Ofernandodosvidros",
  whatsapp: "351926240926",
  whatsappLabel: "+351 926 240 926",
  email: "fernandowindowcleaner@gmail.com",
  city: "Portugal",
};

// TESTE DE PERFORMANCE: coloque a false para esconder TODAS as fotografias
// (hero, galeria, antes/depois, Instagram e história) e medir a rapidez sem imagens.
export const SHOW_MEDIA = true;


export const IMAGES = {
  hero: "/img/hero.webp",
  texture: "/img/texture.webp",
  balcony: "/img/balcony.webp",
  seaside: "/img/seaside.webp",
  team: "/img/team.webp",
  shop: "/img/shop.webp",
  before: "/img/ba1_before.webp",
  after: "/img/ba1_after.webp",
};

export const BEFORE_AFTER = [
  {
    before: "/img/ba1_before.webp",
    after: "/img/ba1_after.webp",
    label: "Janela de arrumos",
    zoomMobile: 1.14,
  },
  {
    before: "/img/ba2_before.webp",
    after: "/img/ba2_after.webp",
    label: "Porta envidraçada",
  },
];

export const GALLERY = [
  { src: IMAGES.hero, label: "A equipa", tall: true },
  { src: IMAGES.balcony, label: "Varandas envidraçadas" },
  { src: IMAGES.texture, label: "O momento da água" },
  { src: IMAGES.seaside, label: "Vidro impecável", tall: true },
  { src: IMAGES.team, label: "O Fernando em ação" },
  { src: IMAGES.shop, label: "Fachada de loja" },
];

export const SERVICES = [
  { id: "comercial", title: "Estabelecimentos Comerciais", desc: "Montras, fachadas e portas de vidro que vendem antes de o cliente entrar.", tag: "01" },
  { id: "residencial", title: "Residências & Condomínios", desc: "Janelas, varandas e marquises com acabamento sem riscos nem marcas.", tag: "02" },
  { id: "solares", title: "Painéis Solares", desc: "Limpeza técnica que devolve rendimento máximo aos seus painéis.", tag: "03" },
  { id: "desportivos", title: "Complexos Desportivos", desc: "Grandes superfícies envidraçadas com meios profissionais e em segurança.", tag: "04" },
  { id: "supermercados", title: "Supermercados & Retalho", desc: "Vidros de grande dimensão limpos com rigor, dentro do vosso horário.", tag: "05" },
  { id: "stands", title: "Stands Automóveis & Showrooms", desc: "Fachadas e montras de grande superfície que fazem cada carro brilhar.", tag: "06" },
];

export const CHAPTERS = [
  { n: "I", title: "A obsessão pela transparência", body: "Começou com um pano, um squeegee e a recusa de aceitar um vidro 'quase limpo'. Um vidro ou está impecável, ou ainda não terminámos." },
  { n: "II", title: "A arte no gesto", body: "Cada passagem tem um ritmo. A água, a espuma e a lâmina trabalham juntas até a luz atravessar sem obstáculos. É isto que chamamos a arte de limpar vidros." },
  { n: "III", title: "Perto de si, em cada trabalho", body: "De montras a varandas com vista para o mar, tratamos cada espaço como se fosse o nosso. Rigor, pontualidade e respeito pela sua casa ou negócio." },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);
export const PROPERTY_TYPES = ["Estabelecimento comercial", "Residência", "Condomínio", "Supermercado / Retalho", "Complexo desportivo", "Outro"];

export const WEEKDAY_SLOTS = ["18:00", "19:00", "20:00", "21:00"];
export const SATURDAY_SLOTS = ["07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00"];

// Devolve as horas disponíveis para uma data "YYYY-MM-DD".
// Seg-Sex: a partir das 18h | Sábado: 07h-18h | Domingo: encerrado
export function slotsForDate(dateStr) {
  if (!dateStr) return [];
  const [y, m, d] = dateStr.split("-").map(Number);
  const day = new Date(y, m - 1, d).getDay(); // 0=Dom, 6=Sáb
  if (day === 0) return [];
  if (day === 6) return SATURDAY_SLOTS;
  return WEEKDAY_SLOTS;
}
